module.exports = __webpack_public_path__ + "static/media/2025-The-Debrief-Feature-Banner-lg@1x.eb98ac14.jpg";